import { useState, useEffect } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
/* eslint-disable */

function StoreDashboard({ supabase, session }) {
  const [data, setData] = useState([])
  const [daily, setDaily] = useState([])
  const [hourly, setHourly] = useState([])
  const storeId = session.user.user_metadata.store_id

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    const { data } = await supabase
      .from('counts')
      .select('*')
      .eq('store_id', storeId)
      .order('timestamp', { ascending: true })
    setData(data)

    const entriesOnly = data.filter(d => d.event === 'entry')

    const dailyMap = {}
    entriesOnly.forEach(d => {
      const date = d.timestamp.split('T')[0]
      dailyMap[date] = (dailyMap[date] || 0) + 1
    })
    setDaily(Object.entries(dailyMap).map(([date, count]) => ({ date, count })))

    const hourlyMap = {}
    entriesOnly.forEach(d => {
      const hour = new Date(d.timestamp).getHours()
      hourlyMap[hour] = (hourlyMap[hour] || 0) + 1
    })
    setHourly(Object.entries(hourlyMap).map(([hour, count]) => ({ hour: `${hour}:00`, count })))
  }

  async function handleLogout() {
    await supabase.auth.signOut()
  }

  const entries = data.filter(d => d.event === 'entry').length
  const exits = data.filter(d => d.event === 'exit').length
  const today = new Date().toISOString().split('T')[0]
  const todayEntries = data.filter(d => d.event === 'entry' && d.timestamp.startsWith(today)).length
  const peakHour = hourly.length > 0 ? hourly.reduce((a, b) => a.count > b.count ? a : b).hour : '-'

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#fafafa' }}>
      <div style={{
        width: '200px',
        flexShrink: 0,
        background: '#fff',
        borderRight: '0.5px solid #e5e5e5',
        padding: '24px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#E24B4A' }}></div>
          <span style={{ fontSize: '16px', fontWeight: '500' }}>Redeye</span>
        </div>
        <div style={{ padding: '8px 12px', borderRadius: '8px', fontSize: '13px', background: '#f5f5f5', fontWeight: '500' }}>
          My store
        </div>
        <div style={{ marginTop: 'auto' }}>
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '8px',
              background: 'transparent',
              border: '0.5px solid #e5e5e5',
              borderRadius: '8px',
              fontSize: '13px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            Sign out
          </button>
        </div>
      </div>

      <div style={{ flex: 1, padding: '32px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ fontSize: '18px', fontWeight: '500' }}>{storeId}</h1>
          <span style={{ fontSize: '13px', color: '#888' }}>{new Date().toDateString()}</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: '12px' }}>
          {[
            { label: 'Total entries', value: entries },
            { label: 'Total exits', value: exits },
            { label: 'Today', value: todayEntries },
            { label: 'Peak hour', value: peakHour }
          ].map(m => (
            <div key={m.label} style={{ background: '#f5f5f5', borderRadius: '8px', padding: '16px' }}>
              <p style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>{m.label}</p>
              <p style={{ fontSize: '24px', fontWeight: '500' }}>{m.value}</p>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: '16px' }}>
          <div style={{ background: '#fff', border: '0.5px solid #e5e5e5', borderRadius: '12px', padding: '20px' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '16px' }}>Daily customer count</p>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={daily}>
                <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="count" fill="#E24B4A" radius={[3,3,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div style={{ background: '#fff', border: '0.5px solid #e5e5e5', borderRadius: '12px', padding: '20px' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '16px' }}>Busiest hours</p>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={hourly}>
                <XAxis dataKey="hour" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="count" fill="#E24B4A" radius={[3,3,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoreDashboard